module.exports = __webpack_public_path__ + "img/gabrielkehr.302c80fa.jpg";